module.exports = __webpack_public_path__ + "media/3_4.d73c0ad6.wav";